import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import xss from "xss";

import { MaxShipmentError } from "./errors/MaxShipmentError";
import CONFIG from "../config";
import Price from "../type/price";
import { basketActions } from "../actions";

const ShippingChoice = (props) => {
  const basketStorage = useSelector((state) => state.basketStorage);
  const configStorage = useSelector((state) => state.configStorage);
  const kundenStorage = useSelector((state) => state.kundenStorage);
  const mandantStorage = useSelector((state) => state.mandantStorage);
  const [filiale, setFiliale] = useState(null);
  const dispatch = useDispatch();

  const handleUpdateBasketSum = useCallback((e) => {

    if (!e || !e.target) return;
    dispatch(basketActions.setDoShip(xss(e.target.value)));
    dispatch(basketActions.updateSum());
    if (e.target.value === "yes") setFiliale(null);
  }, [dispatch]);

  useEffect(()=>{
    //console.info("Render ShippingChoice - step2");
    const filialen = basketStorage.getFilialen(configStorage.isKundenShop());
    if (filiale && !filialen.find(f => f.value === Number(filiale))) setFiliale(null);
    if (!basketStorage.hasShippingChoice || configStorage.isAnkaufShop()) {
      basketStorage.doShip = "no";
    }
  },[basketStorage, configStorage, filiale])

  const handleSelectedFiliale = useCallback((e) => {
    if (!e || !e.target) return;
    const value = xss(e.target.value);
    if (value) {
      const f = (basketStorage.filialen || []).find(f => Number(f.value) === Number(value)) || null;
      dispatch(basketActions.setSelectedFiliale(f));
      setFiliale(value);
    }
  }, [basketStorage.filialen, dispatch]);

  const renderFilialeOptions = useMemo(() => {
    //Beim Ankauf wird automatisch die erste Filiale (Hauptstelle) zurückgegeben
    if (configStorage.isAnkaufShop() && basketStorage.hasFilialen() && !mandantStorage.ablieferadresseAnkauf()) {
      const f = basketStorage.getFilialen(configStorage.isKundenShop())[0] || {};
      return [<option key={f.value} value={f.value}>{f.name}</option>];
    }

    const filialen = basketStorage.getFilialen(configStorage.isKundenShop());
    const items = filialen.map(f => <option key={"filiale" + f.value} value={f.value}>{f.name}</option>);
    items.unshift(<option key="none" value="NONE">- Filiale wählen -</option>);
    return items;
  }, [basketStorage, configStorage, mandantStorage]);

  const minOrderValueFiliale = mandantStorage && typeof mandantStorage.getMinOrdervalueFiliale === "function"
    ? Number(mandantStorage.getMinOrdervalueFiliale())
    : 0;

  return (
    <div className="ser-shipping">
      {basketStorage.hasShippingChoice && !configStorage.isAnkaufShop()
        ? (
          <div className="ser-textpanel ser-shipopts form-check" aria-label="Ihre Versandoptionen:">
            <span className="ser-label ser-iblock">
              Ihre Versandoptionen:
            </span>
            {basketStorage.hasFilialen()
              ? (
                <span className="ser-shipopt ser-iblock">
                  <input
                    id="serDontShip"
                    type="radio"
                    name="serDoShip"
                    className="form-check-input"
                    value="no"
                    checked={basketStorage.doShip === "no"}
                    onChange={handleUpdateBasketSum}
                    disabled={basketStorage.locked}
                  />
                  <label className="ser-shipopt-label form-check-label" htmlFor="serDontShip">
                    {" "}
                    Abholung in der Filiale
                  </label>
                </span>
              )
              : null
            }
            { (!configStorage.isDeuBa() || 
              (!!kundenStorage.getKunde().ort && 
              !!kundenStorage.getKunde().plz && !!kundenStorage.getKunde().strasse1)) ?
              (<span className="ser-shipopt ser-iblock form-check">
                <input
                  id="serDoShip"
                  type="radio"
                  name="serDoShip"
                  className="form-check-input"
                  value="yes"
                  checked={basketStorage.doShip === "yes"}
                  onChange={handleUpdateBasketSum}
                  disabled={basketStorage.locked}
                />
                <label className="ser-shipopt-label form-check-label" htmlFor="serDoShip">
                  {" "}
                  Direktversand nach Hause
                </label>
              </span>): null
          }
          </div>
        )
        : (
          <MaxShipmentError />
        )
      }
      {basketStorage.sumLessthanMinOdervalueFiliale  && !configStorage.isAnkaufShop()
        ? (
          <div className="ser-textpanel ser-grey">
            Abholung in Ihrer Bank ist nur über <strong className="text-primary">{Price.markify(minOrderValueFiliale)}</strong> EUR möglich.
          </div>
        )
        : null
      }
      {basketStorage.hasFilialChoice
        ? (
          <div className="ser-textpanel ser-filialpanel">
            <span className="ser-iblock ser-label" id="labelFilialen">
              {!configStorage.isAnkaufShop()
                ? "Bitte wählen Sie Ihre Filiale:"
                : "Ablieferfiliale:"}
            </span>
            <div className="ser-iblock ser-filialselect">
              <select
                name="spkFiliale"
                className="ser-filiale form-select"
                value={filiale || "NONE"}
                onChange={handleSelectedFiliale}
                aria-labelledby="labelFilialen"
              >
                {renderFilialeOptions}
              </select>
            </div>
          </div>
        )
        : null
      }
      {!basketStorage.hasFilialChoice && configStorage.isKundenShop()
        ? (
          <div className="ser-textpanel">
            <span className="ser-iblock" id="hintDirectDelivery">
              <b>
                Hinweis: Beim "Direktversand nach Hause" werden alle Bestellungen, die bis 14:30 Uhr erfasst wurden, am gleichen Tag verschickt. 
                Die Zustellung erfolgt am Folgetag (Montag - Freitag). Bitte sorgen Sie dafür, dass die Bestellung an der angegebenen Lieferadresse entgegengenommen 
                werden kann (bei Bestellungen nach 14:30 Uhr entsprechende Verschiebung um 1 Tag).
              </b>
            </span>           
          </div>
        )
        : null
      }
      {CONFIG.isSortenShop()
        ? <div className="ser-textpanel ser-grey">
          Informationen zu Währungen, Ein- und Ausfuhrbestimmungen und
          weiterführende Details finden Sie{" "}
          <a
            className="ser-link"
            href="https://www.bacosystem.de/bayernlb.php"
            target="_blank"
            rel="noopener noreferrer"
            title="Informationen zu Währungen, Ein- und Ausfuhrbestimmungen und
          weiterführende Details"
            aria-label="Informationen zu Währungen, Ein- und Ausfuhrbestimmungen und
          weiterführende Details"
          >
            hier
          </a>
          .
        </div>
        : null
      }
    </div>
  );
};

export default ShippingChoice;
